// LOANS
const LOADING_LOANS = 'LOADING_LOANS';
const SET_GROUP_LOANS = 'SET_GROUP_LOANS';
const SET_SALARY_ADVANCE_LOANS = 'SET_SALARY_ADVANCE_LOANS';
const SET_LOAN_ERROR = 'LOAN_ERROR';

export {
  LOADING_LOANS,
  SET_SALARY_ADVANCE_LOANS,
  SET_GROUP_LOANS,
  SET_LOAN_ERROR,
};
